import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './Card.module.scss';
import { rosterData } from 'utilities/roster.js';
import { Droppable } from 'react-beautiful-dnd';
import customIsoString from 'utilities/custom-iso-string';
import nlDateString from 'utilities/nl-date-string';

/**
 * Import components
 */
import CardItem from './CardItem/CardItem';
import AgendaItem from 'components/UI/AgendaItem/AgendaItem';

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Import selectors
 */

import getScheduleByDay from 'selectors/schedule/day';
import getHomeworkByDay from 'selectors/homework/homework-day';
import getHolidayByDate from 'selectors/holiday/holi-day';
import EmptyCardItem from './EmptyCardItem/EmptyCardItem';

//import actions
import {
    homeworkDate,
    homeworkTimeslot
} from 'actions/new-homework';

import { timeslot, startDate } from 'actions/new-timeslot';

const mapStateToProps = (state, props) => {
    return {
        schedule: getScheduleByDay(state, props),
        homework: getHomeworkByDay(state, props),
        holiday: getHolidayByDate(state, props),
        user: state.authentication.user,
        user_subjects: state.user_subject
    };
};

const mapDispatchToProps = {
    homeworkDate,
    homeworkTimeslot,
    timeslot,
    startDate
};

class Card extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            dayOfWeek: '',
            days: [ 'Zondag','Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag' ],
            months: [ 'januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december' ],
            currentDate: '',
            showPopup: false,
            showCardConflict: false,
            selectedResolve: null,
        };

        this.handleCardItemClick    = this.handleCardItemClick.bind(this);
        this.setWrapperRef          = this.setWrapperRef.bind(this);
        this.handleClickOutside     = this.handleClickOutside.bind(this);
        this.toggleClearPopup       = this.toggleClearPopup.bind(this);
        this.handleEmptyCardItemClick   = this.handleEmptyCardItemClick.bind(this);
    }

    componentDidMount() {
        
    }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleCardItemClick(index) {
        if (this.props.nodate) { //we have no date, so we are in the schedule adjustment page
            this.props.handleCardItemClick(this.props.date.getDay(), index);
        }
    }

    checkDate(date) {
        const today = new Date();
        return date.getDate() == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear();
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({
                showPopup: false
            });
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
    }

    toggleClearPopup() {
        if (this.state.showPopup) {
            document.removeEventListener('mousedown', this.handleClickOutside);
        } else {
            document.addEventListener('mousedown', this.handleClickOutside);
        }
        this.setState(prevState => {
            return {
                showPopup: !prevState.showPopup
            };
        });
    }

    handleEmptyCardItemClick(order) {
        this.props.onScheduleItemClick();
        let date = customIsoString(this.props.date).split('T')[0];
        this.props.startDate(date);
        this.props.timeslot(order);
        this.props.homeworkTimeslot(order);
        this.props.homeworkDate(date);
    }

    render() {
        const { date, dark, nodate, click, schedule, user, user_subjects, isSchedule, style, holiday, draggingASchedule } = this.props;
        const { days, months } = this.state;
        const amountOfCardItems = user.amount_of_cards;

        let title = (this.checkDate(date) && !isSchedule) ? 'Vandaag' : '';

        let dateString = nodate ? '' : date.getDate() + ' ' + months[date.getMonth()];
        let cardItems = [];
        let dayOfweek = date.getDay();
        let lastTimeSlotItem = 0;
        
        for (var i = 1; i <= amountOfCardItems; i++) {

            let currentTimeSlotItem = this.props.schedule.filter((scheduleItem) => scheduleItem.timeslot == i);

            //lets see if we have a schedule item that should render here because it has a duration > 1
            //if (currentTimeSlotItem.length == 0) {
            if (lastTimeSlotItem.duration > 1 && i < (lastTimeSlotItem.timeslot + lastTimeSlotItem.duration) ) {
                currentTimeSlotItem.push( {
                    ...lastTimeSlotItem,
                    block: true,
                    last: i == (lastTimeSlotItem.timeslot + lastTimeSlotItem.duration - 1),
                });
            }
            //}

            if (currentTimeSlotItem.length > 0) {
                lastTimeSlotItem = currentTimeSlotItem[0];

                let filteredHomework = this.props.homework.filter((homeworkItem) => homeworkItem.user_subject_id == currentTimeSlotItem[0].user_subject_id && (homeworkItem.timeslot == i || (currentTimeSlotItem[0].block && (i >= homeworkItem.timeslot && i < (homeworkItem.timeslot + currentTimeSlotItem[0].duration) ))));

                cardItems.push({ object:<CardItem
                    handleClick={this.handleCardItemClick}
                    dark={dark}
                    date={date}
                    times={this.props.user.show_hours && this.props.user.times}
                    weekend={dayOfweek == 0 || dayOfweek == 6}
                    period={currentTimeSlotItem[0]}
                    homework={filteredHomework.length > 0 ? filteredHomework[0] : null}
                    isSchedule={isSchedule}
                    past={this.props.past}
                    draggingASchedule={draggingASchedule}
                    key={i}
                    order={i}
                    conflictingItems={currentTimeSlotItem}
                    conflict={currentTimeSlotItem.length > 1}
                    selectConflictResolve={this.setConflictResolve}
                    resolveConflict={this.state.selectedResolve}
                />, block: currentTimeSlotItem[0].block ? true: false, id: currentTimeSlotItem[0].id });
            } else {
                cardItems.push({ object: <EmptyCardItem 
                    draggingASchedule={draggingASchedule}

                    weekend={dayOfweek == 0 || dayOfweek == 6}
                    handleClick={this.handleEmptyCardItemClick}
                    order={i}
                    key={`empty-${customIsoString(date, true)}-${i}`} 
                />, empty: true });
            }
        }
        let customCardId = nlDateString(date).replace(/-/g,'');
        return (

            <div id={title == 'Vandaag' ? 'CardToday' : customCardId} styleName={`card-background ${(!isSchedule && (holiday && holiday.special == 0)) ? 'isHoliday' : ''} ${this.props.large ? 'large' : ''}`} style={style}>
                {this.props.past ? <div styleName='inside-wrapper'/> : null }
                {this.props.large ? this.props.children :
                    <Fragment>
                        <div styleName='top-card'>
                            <h2 styleName={`title ${title == 'Vandaag' ? 'today' : ''} ${holiday ? 'isHoliday' : ''}`} >{title && title || days[dayOfweek]}</h2>
                            <div styleName='clear-popup' onClick={this.toggleClearPopup} ref={this.setWrapperRef}>
                                <FontAwesomeIcon styleName='icon' icon={[ 'far', 'ellipsis-h' ]}/>
                                <div styleName={`popup ${this.state.showPopup ? '' : 'hidden'}`}>
                                    <div styleName='clear-options'>
                                        <div styleName='clear-option' onClick={() => this.props.handleClearOptionClick('dag', date)}>
                                            <p>Maak deze dag leeg (excl. agenda items)</p>
                                        </div>
                                        <div styleName='clear-option' onClick={() => this.props.handleClearOptionClick('week', date)}>
                                            <p>Maak deze week leeg (Ma / Zo, excl. agenda items)</p>
                                        </div>
                                        <div styleName='clear-option' onClick={() => this.props.handleClearOptionClick('all', date)}>
                                            <p>Maak vanaf hier alles leeg (excl. agenda items)</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p styleName={`date ${(holiday && !isSchedule) ? 'isHoliday' : ''}`}>{( !isSchedule && (holiday && holiday.special == 1)) && <div styleName='single-holiday-indicator'></div>}{dateString}</p>
                        {
                            holiday && (
                                <div styleName={`holiday-wrapper ${title == 'Vandaag' ? 'today' : ''}`} style={  (!isSchedule && holiday.special  == 1) ? { marginBottom: '7px' } : {}}>
                                    {   (!isSchedule && (holiday && holiday.special == 0)) &&
                                        <div styleName='holiday'></div>
                                    }
                                    {
                                        ( !isSchedule && (holiday && holiday.is_first == 1)) && (
                                            <div styleName='holiday-name'>{holiday.name}</div>
                                        )
                                    }
                                </div>
                            )
                        }
                        {
                            cardItems.map((cardItem, index) => {
                                //determine drop enabled for this cardItem
                                let isDropDisabled = false;
                                if (!cardItem.empty) {
                                    
                                    if (cardItem.id != draggingASchedule.id || (draggingASchedule.duration + index) > amountOfCardItems) { //when the cardItem is not empty, drop is only allowed when an event is dropping over itself, and the duration of the event fits in the remaining cardItems

                                        isDropDisabled = true;
                                        
                                    }
                                }

                                if (cardItem.empty && (draggingASchedule.duration + index) > amountOfCardItems ) { //when the cardItem is empty, only requirement is that the duration of the event fits within the remaining cardItems
                                    isDropDisabled = true;
                                }

                                return <Droppable isDropDisabled={isDropDisabled} droppableId={`empty-${customIsoString(this.props.date, true)}-${index + 1}`} key={index} >
                                    {(provided, snapshot ) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps} 
                                            style={snapshot.isDraggingOver ? { backgroundColor: 'rgba(0,0,0,0.3)', margin: '0 10px 5px 10px',minHeight:'40px' } : { margin: '0 10px 5px 10px',minHeight:'40px' } }>
                                            {cardItem.object}
                                        </div>
                                    )
                                    }
                                </Droppable>;
                            })
                        }
                        <hr style={{ color: '#e5e5e5', backgroundColor: '#e5e5e5', opacity: '0.2', width: '172px' }}/>
                        <AgendaItemWrapper
                            handleClick={this.props.onAgendaItemClick}
                            dark={dark}
                            date={date}
                            draggingASchedule={draggingASchedule}
                            weekend={dayOfweek == 0 || dayOfweek == 6}
                            items={this.props.schedule.filter((item) => item.timeslot == 99)}
                            handleAgendaInputClick={this.props.handleAgendaInputClick}
                            // alle items meegeven met timeslot 99
                        />
                    </Fragment>
                }
            </div>
        );
    }
}

class AgendaItemWrapper extends Component {
    constructor() {
        super();

        this.handleClick            = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.handleClick(this.props.items.length > 0);
    }

    render() {
        return (
            <AgendaItem
                {...this.props}
                handleClick={this.handleClick}
                // alle items meegeven met timeslot 9
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Card);
